import { render, staticRenderFns } from "./LtkCoachmark.vue?vue&type=template&id=4684e2f6&scoped=true"
import script from "./LtkCoachmark.vue?vue&type=script&setup=true&lang=ts"
export * from "./LtkCoachmark.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LtkCoachmark.vue?vue&type=style&index=0&id=4684e2f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4684e2f6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CCoachmark: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/components/CCoachmark/CCoachmark.vue').default})
